import type { TablePaginationConfig } from 'antd';

export const DEFAULT_PAGINATION_CONFIG = {
  defaultPageSize: 20,
  defaultCurrent: 1,
  total: 0,
  pageSizeOptions: [10, 20, 50, 100] as number[],
  hideOnSinglePage: false,
  showSizeChanger: true,
  showPrevNextJumpers: false,
} satisfies TablePaginationConfig;

export enum PaginationField {
  Page = 'page',
  PageSize = 'pageSize',
  /**
   * @deprecated Use `sorts` instead.
   */
  Sort = 'sort',
  Sorts = 'sorts',
}
